import { Not, NumberEquals, NumberGreaterThan } from '@vendasta/automata';
import { DataFilter } from './interface';
import { PositiveIntegerComponent } from './dynamic-options/positive-integer/positive-integer.component';
import { PositiveIntegerDisplayService } from './dynamic-options/positive-integer/positive-integer-display.service';

const OPEN_OPPORTUNITIES = '{.computed_properties.open_opportunity_count}';
export class OpenOpportunities implements DataFilter {
  rules = [
    new Not(new NumberGreaterThan(OPEN_OPPORTUNITIES)),
    new NumberEquals(OPEN_OPPORTUNITIES),
    new NumberGreaterThan(OPEN_OPPORTUNITIES),
  ];
  dataEntryComponentList = [PositiveIntegerComponent, PositiveIntegerComponent, PositiveIntegerComponent];
  displayService = PositiveIntegerDisplayService;
  label = 'AUTOMATIONS.EDITOR.FILTERS.OPEN_OPPORTUNITIES_DATA.DATA_LABELS.OPEN_OPPORTUNITIES';
  comparisonLabels = [
    'AUTOMATIONS.EDITOR.FILTERS.OPEN_OPPORTUNITIES_DATA.COMPARISON.LESS_THAN_EQUAL',
    'AUTOMATIONS.EDITOR.FILTERS.OPEN_OPPORTUNITIES_DATA.COMPARISON.EQUALS',
    'AUTOMATIONS.EDITOR.FILTERS.OPEN_OPPORTUNITIES_DATA.COMPARISON.GREATER_THAN',
  ];
}

export const OPPORTUNITIES_COMPONENTS: Map<string, DataFilter> = new Map<string, DataFilter>([
  [OPEN_OPPORTUNITIES, new OpenOpportunities()],
]);
